import { StyledCardContent, StyledCardHead, StyledCardHeadRight } from '../StyledComponents';
import { RowItemHead } from './details/RowItemHead';
import { RowItemBody } from './details/RowItemBody';
import { RowItemButtons } from './RowItemButtons';
import { ILockerGateItem } from 'api/interfaces/lockerGate';

import { getLockerItemIcons } from './icons/getLockerItemIcons';
import { StatusBadge } from './StatusBadge';
import { TimeItem } from './details/TimeItem';

interface LockerItemProps {
	lockerGateItem: ILockerGateItem;
}

export const LockerItem = ({ lockerGateItem }: LockerItemProps) => {
	const visibleIcons = getLockerItemIcons(lockerGateItem);

	return (
		<>
			<StyledCardContent>
				<StyledCardHead>
					<RowItemHead {...lockerGateItem} />
					<StatusBadge
						lockerStatus={lockerGateItem.lockerStatus}
						tenantName={lockerGateItem.tenantName}
						isCompany={lockerGateItem.lockerDetails?.isCompany}
						orderItemTypeTag={lockerGateItem.lockerDetails?.orderItemTypeTag}
					/>
					<StyledCardHeadRight>
						<TimeItem
							lastOpenedAtUTC={lockerGateItem.lastOpenedAtUTC}
							openType={lockerGateItem.openStatus}
							openDurationInMinutes={lockerGateItem.openDurationInMinutes}
							isMonitored={lockerGateItem.isMonitored}
						/>
						{visibleIcons.map((icon, index) => (
							<span
								key={index}
								style={{
									width: 24,
									display: 'inline-flex',
									justifyContent: 'center',
									alignItems: 'center',
									flexShrink: 0,
								}}
							>
								{icon}
							</span>
						))}
					</StyledCardHeadRight>
				</StyledCardHead>
				<RowItemBody item={lockerGateItem} />
			</StyledCardContent>
			<RowItemButtons {...lockerGateItem} />
		</>
	);
};
